import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { useQueryClient } from "@tanstack/react-query";

import { useStartAnalysis } from "@/features/matches";
import { useApiErrorMessage } from "@/shared/api";
import { Button } from "@/shared/ui/button";

import { analysisQueryOptions } from "../../api/analysisQueryOptions";
import type { Analysis } from "../../model/Analysis";

const STARTING = msg({ id: "analysis.start.starting", message: "Starting…" });

type StartAnalysisButtonProps = {
  matchId: number;
  label: MessageDescriptor;
  variant?: "default" | "outline";
};

// Кнопка запуска разбора матча и текст ошибки запуска (лимит, матч не готов и т. п.).
export const StartAnalysisButton = ({ matchId, label, variant }: StartAnalysisButtonProps) => {
  const { _ } = useLingui();
  const queryClient = useQueryClient();
  // Новый разбор сразу кладётся в кэш: экран показывает его шаги без лишнего запроса.
  const startAnalysis = useStartAnalysis({
    onStarted: (analysis) => {
      queryClient.setQueryData<Analysis>(analysisQueryOptions(analysis.id).queryKey, analysis);
    },
  });
  const error = useApiErrorMessage(startAnalysis.error);
  return (
    <div className="flex flex-col items-start gap-2">
      <Button
        type="button"
        variant={variant}
        loading={startAnalysis.isPending}
        onClick={() => {
          startAnalysis.start(matchId);
        }}
      >
        {startAnalysis.isPending ? _(STARTING) : _(label)}
      </Button>
      {error !== null && (
        <p role="alert" className="text-sm text-bad">
          {error}
        </p>
      )}
    </div>
  );
};
